import React, { useEffect, useState } from "react"
import FileSaver from "file-saver"

import Api from "../../core/api"
import { API_SEARCH } from "../../core/constants"
import data from "../../assets/statesList.json"
import ResultsTable from "./ResultsTable"
import { Button } from "primereact/button"
import { MultiSelect } from "primereact/multiselect"
import { InputTextarea } from "primereact/inputtextarea"
import { InputText } from "primereact/inputtext"
import { logUserActivity, Toast, UserActivity } from "../../services"
import { CheckboxField } from "@wk/components-react16"

const FILTER_FLD = "domesticJurisdiction"

const SearchEntity = () => {
  const filterTypeObj = {
    searchFieldType: '2',
    searchType: false,
    showBulk: false,
    isStateId: '1'
  }
  const [results, setResults] = useState([])
  const [totalItems, setTotalItems] = useState(0)
  const [pagination, setPagination] = useState({ page: 0, pageSize: 10 })
  const [q, setQ] = useState("")
  const [bq, setBq] = useState("")
  const [fq, setFq] = useState([])
  const [loading, setLoading] = useState(false)
  const [isStateId, setIsStateId] = useState('1')
  const [searchFieldType, setSearchFieldType] = useState('2')
  //const [exactSearch, setExactSearch] = useState(false)
  const [showBulk, setShowBulk] = useState(false)
  const [searchType, setSearchType] = useState(false)
  const [downLoadLoading, setDownLoadLoading] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const [qString, setQString] = useState("");
  const [searchFilterTypeObj, setSearchFilterTypeObj] = useState(filterTypeObj);
  const [officersData, setOfficersData] = useState(false);
  const [showOfficersDataColumn, setShowOfficersDataColumn] = useState(false);

  const payload: any = {
    q: "",
    size: pagination.pageSize,
    start: pagination.page,
    fq: "",
    searchFields: "entityName",
  }

  const buildPayload = (type: boolean) => {
    if (type) {
      payload.q = bq
        .split("\n")
        .map(item => wrapTextWithQuotes(item))
        .join(" ")
      setQ("")
    } else {
      payload.q = wrapTextWithQuotes(q)
      setBq("")
    }
    setQString(payload.q)
    payload.fq = "sosPurgedInd ne 'Y'";
    if (fq.length > 0) {
      payload.fq += ` and search.in(${FILTER_FLD}, '${escapeQuote(fq.join("|"))}', '|')`
    }
    

    if (searchFilterTypeObj.searchFieldType === '3' || searchFilterTypeObj.isStateId === '2') {
      const fl1 = exactNameFilter(type ? bq : q)
      if (fl1) {
        let searchIn = searchFilterTypeObj.isStateId == '1' ? "beCompressNm" : (searchFilterTypeObj.isStateId === '2' ? "stateId" : "agentNmNormalized");
        payload.fq += ` and search.in(${searchIn}, '${escapeQuote(fl1.join("|"))}', '|')`
      }
    }
    

    if(searchFilterTypeObj.isStateId === '1') {
      payload.searchFields = searchFilterTypeObj.searchFieldType === '3' ? "beCompressNm" : (searchFilterTypeObj.searchFieldType === '1' ? 'entityNameNormalized' : "entityName")
    } else if (searchFilterTypeObj.isStateId === '2') {
      payload.searchFields = "stateId"
    } else if (searchFilterTypeObj.isStateId === '3') {
      payload.searchFields = searchFilterTypeObj.searchFieldType === '2' ? "agentNm" : 'agentNmNormalized'
    }

    payload.officers = officersData;
    // payload.searchFields = searchFilterTypeObj.isStateId === '2'
    //   ? "stateId"
    //   : (searchFilterTypeObj.searchFieldType === '3' ? "beCompressNm" : (searchFilterTypeObj.searchFieldType === '1' ? 'entityNameNormalized' : "entityName"))
  }

  const handleSearch = (e: { preventDefault: () => void }) => {
    setLoading(true)
    const p = { page: 0, pageSize: 10 }
    setPagination(p)
    payload.start = p.page * p.pageSize
    payload.size = p.pageSize
    if (e) e.preventDefault()
    setSearchType(showBulk)
    setIsSearch(true);
    searchFilterTypeObj.searchFieldType = searchFieldType;
    searchFilterTypeObj.searchType = showBulk;
    searchFilterTypeObj.showBulk = showBulk;
    searchFilterTypeObj.isStateId = isStateId;
    setSearchFilterTypeObj({ ...searchFilterTypeObj });
    search(showBulk)
  }

  const handleSearchParams = (params: { page: number; pageSize: number }) => {
    setPagination(params)
    payload.start = params.page * params.pageSize
    payload.size = params.pageSize;
    setSearchFieldType(searchFilterTypeObj.searchFieldType);
    setSearchType(searchFilterTypeObj.searchType);
    setShowBulk(searchFilterTypeObj.showBulk);
    setIsStateId(searchFilterTypeObj.isStateId);
    search(searchType);
  }

  const downloadResults = (params: { page: number; pageSize: number }) => {
    const { start, size } = payload
    setDownLoadLoading(true)
    payload.start = 0
    payload.size = 1000
    buildPayload(searchType)

    const subViewName = (payload.searchFields == "entityNameNormalized" ? 'Begins' : (payload.searchFields == "beCompressNm" ? 'Exact' : 'Normal')) + ' | ' + (searchFilterTypeObj.showBulk ? 'Bulk' : 'Single') + ' | ' + (payload.searchFields == 'stateId' ? 'State ID' : 'Entity');
    let userActivity: UserActivity = {
      action: 'Download Button Click',
      page: 'Entity Search',
      viewName: 'Download Search Results',
      subViewName: subViewName,
      entityName: payload.q
    }
    logUserActivity(userActivity);
    Api.postRequestBlob(API_SEARCH.CSV_DOWNLOAD, payload).then((blob: any) => {
      const fileName = "Search_Result.xlsx"
      FileSaver.saveAs(
        new Blob([blob], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
        fileName,
      )
      setDownLoadLoading(false)
    })
    payload.start = start
    payload.size = size
  }



  const wrapTextWithQuotes = (text: string) => {
    if (searchFilterTypeObj.searchFieldType === '1') {
      return preText(text)
    }
    if (!(text = text.trim()) || text === "*") {
      return text
    }
    if (searchFilterTypeObj.searchFieldType === '3') {
      text = compressText(text)
    }
    if (searchFilterTypeObj.searchFieldType !== '1') {
      if (!text.startsWith('"')) {
        text = `"${text}`
      }
      if (!text.endsWith('"')) {
        text = `${text}"`
      }
    }
    if (searchFilterTypeObj.searchFieldType === '2') {
      text = normalText(text)
    }
    return text;
  }

  const exactNameFilter = (text: string) => {
    if (!(text = text.trim()) || text === "*") {
      return null
    }
    return text.split("\n").map(tkn => searchFilterTypeObj.isStateId === '2' ? tkn : compressText(tkn))
  }

  const compressText = (text: string) => {
    return text.replace(/ and /gi, "&").replace(/[^\w&%*]/gi, "").toUpperCase()
  }

  const preText = (text: string) => {
    return text.trimStart().replace(/\s{1,}/gi, "_").replace(/&/gi, "and").replace(/[^\w]/gi, "").toUpperCase() + "*";
  }

  const escapeQuote = (text: string) => {
    return text ? text.replaceAll("'", "''") : text;
  }

  const normalText = (text: string) => {
    let newText = text;
    if (text.includes(" & ")) {
      const text1 = text.replace(/ & /gi, " and ");
      newText += ' ' + text1;
    }
    if (text.includes(" and ")) {
      const text2 = text.replace(/ and /gi, " & ");
      newText += ' ' + text2;
    }
    return newText;
  }

  const handleReset = () => {
    setResults([])
    setQ("")
    setBq("")
    setFq([])
    //setExactSearch(false)
    setPagination({ page: 0, pageSize: 10 })
    setShowBulk(false)
    setSearchType(false)
    setIsSearch(false)
    setIsStateId('1')
    setQString("")
    setSearchFieldType("2");
    setSearchFilterTypeObj(filterTypeObj);
    setOfficersData(false);
    setShowOfficersDataColumn(false);

  }

  const search = (type: boolean) => {
    setLoading(true)
    buildPayload(type)
    const subViewName = (payload.searchFields == "entityNameNormalized" ? 'Begins' : (payload.searchFields == "beCompressNm" ? 'Exact' : 'Normal')) + ' | ' + (searchFilterTypeObj.showBulk ? 'Bulk' : 'Single') + ' | ' + (payload.searchFields == 'stateId' ? 'State ID' : 'Entity');
    let userActivity: UserActivity = {
      action: 'Search Icon Click',
      page: 'Entity Search',
      viewName: 'Search Results --||--page number:' + ((payload.start / payload.size) + 1) + '--||--' + 'page size:' + payload.size,
      subViewName: subViewName,
      entityName: payload.q
    }
    setShowOfficersDataColumn(officersData);
    logUserActivity(userActivity);
    Api.postRequest(API_SEARCH.SEARCH, payload).then(
      (res: any) => {
        setResults(res.results)
        setTotalItems(res.totalItems)
        setLoading(false)
      },
      (err: any) => {
        Toast(err.error, "error")
        setLoading(false)
      },
    )
  }

  const handleOptionChange = (changeEvent: any) => {
    setSearchFieldType(changeEvent.target.value)
  }
  const handleStateIdChange = (changeEvent: any) => {
    setIsStateId(changeEvent.target.value);
    if (changeEvent.target.value === '2') {
      setSearchFieldType('2')
    }
  }

  return (
    <>
      {/* <h4 className="text-center">
        <img
          src="https://cdn.wolterskluwer.io/wk/fundamentals/1.x.x/logo/assets/white-wheel-medium.svg"
          alt="Wolters Kluwer"
          className="wk-logo wk-logo-medium mx-2"
        />
        SoS Search Engine
      </h4> */}
      <div className="row mb-2">
        <div className="col-md-12 mx-auto">
          <div className="mb-1" style={{ display: "flex" }}>
            <div className="switch-wrapper"><i className="wk-icon-sliders pb-1 mr-2"></i></div>
            <div className="switch-wrapper">
              <div className="switch">
                <input type="radio" id="switch-radio1" name="radio" value="1" readOnly
                  onClick={handleOptionChange} disabled={isStateId === '2'} />
                <label htmlFor="switch-radio1" className={`active ${isStateId === '2' ? 'disabled' : ''}`}>Begins</label>

                <input type="radio" id="switch-radio2" name="radio" value="2" readOnly
                  checked={searchFieldType === '2'}
                  onClick={handleOptionChange} disabled={isStateId === '2'} />
                <label htmlFor="switch-radio2" className={`active ${isStateId === '2' ? 'disabled' : ''}`}>Normal</label>

                <input type="radio" id="switch-radio3" name="radio" value="3" readOnly
                  onClick={handleOptionChange} disabled={isStateId === '2'} />
                <label htmlFor="switch-radio3" className={`active ${isStateId === '2' ? 'disabled' : ''}`}>Exact</label>

                <span id="active-label"></span>
              </div>
            </div>
            <div className="switch-wrapper switch-button ml-2">
              <div className="b1" id="button-1">
                <input id="bulk-search" type="checkbox" name="checkbox" checked={showBulk} onChange={e1 => {
                  setShowBulk(e1.target.checked)
                }} className="checkbox" />
                <div className="knobs">
                  <span>Single</span>
                </div>
                <div className="layer"></div>
              </div>
            </div>
            {/* <div className="switch-wrapper switch-button ml-2">
              <div className="b1" id="button-2">
                <input id="stateid-search" type="checkbox" name="checkbox" checked={isStateId} onChange={e => {
                  setIsStateId(e.target.checked)
                  if (e.target.checked) setSearchFieldType("2")
                }} className="checkbox" />
                <div className="knobs knobs1">
                  <span>Entity</span>
                </div>
                <div className="layer"></div>
              </div>
            </div> */}
            <div className="switch-wrapper ml-2 mr-3">
              <div className="switch state-id-switch">
                <input type="radio" id="switch-radio4" name="radio2" value="1" readOnly  
                  onClick={handleStateIdChange} checked={isStateId === '1'}/>
                <label htmlFor="switch-radio4" className="active">Entity</label>
                <input type="radio" id="switch-radio5" name="radio2" value="2" readOnly 
                  onClick={handleStateIdChange} />
                <label htmlFor="switch-radio5" className="active">State ID</label>
                <input type="radio" id="switch-radio6" name="radio2" value="3" readOnly 
                  onClick={handleStateIdChange}/>
                <label htmlFor="switch-radio6" className="active">Agent Name</label>
                <span id="active-label2"></span>
              </div>
            </div>
            <CheckboxField  label="Show Officer Data">
              <input
                name="checkbox"
                type="checkbox"
                checked={officersData}
                onChange={(e: any) => {
                    setOfficersData(e.target.checked)
                }}
              />
            </CheckboxField>
          </div>
          <form className="d-flex" onSubmit={handleSearch}>
            <div className="p-inputgroup p-inputtext-sm multiselect-custom text-sm">
              <MultiSelect
                optionLabel="name"
                optionValue="abbreviation"
                showClear={true}
                value={fq}
                options={data}
                onChange={e => setFq(e.value)}
                placeholder="Filter..."
                maxSelectedLabels={3}
                className="text-sm p-inputtext-sm"
              />
              {showBulk ? (
                <InputTextarea
                  name="bulk-search"
                  id="bulk-search"
                  placeholder="Bulk search..."
                  rows={3}
                  value={bq}
                  onChange={e => setBq(e.target.value)}
                  className="text-sm p-inputtext-sm"
                />
              ) : (
                <InputText
                  className="text-sm p-inputtext-sm"
                  type="search"
                  name="search"
                  id="search"
                  placeholder="Type to search..."
                  aria-label="Search"
                  value={q}
                  onChange={e => setQ(e.target.value)}
                />
              )}
              <Button
                title="search"
                onClick={handleSearch}
                name="submit"
                type="submit"
                icon="pi pi-search"
                className="p-button-primary"
              />
              <Button
                title="Reset"
                onClick={handleReset}
                name="reset"
                type="button"
                icon="pi pi-undo"
                className="border-round-right p-button-outlined p-button-secondary"
              />
            </div>
          </form>
        </div>
      </div>
      <div className="wrapper">
        {isSearch ? (
          <>
            {loading ? (
              <p className="text-center">Loading...</p>
            ) : (
              <>
                <ResultsTable
                  rowCount={totalItems}
                  rows={results}
                  pageData={pagination}
                  handleServerSearch={handleSearchParams}
                  downloadResults={downloadResults}
                  downLoadLoading={downLoadLoading}
                  qString={qString}
                  showOfficersDataColumn={showOfficersDataColumn}
                />
              </>
            )}
          </>
        ) : null}
      </div>
    </>
  )
}
export default SearchEntity
